{
  "nl": {
    "unit": {
      "actions": {
        "bulk": {
          "activate": "Units activeren",
          "allow_customer_issue_creation": "Klanten nieuwe punten laten melden",
          "block_customer_issue_creation": "Klanten geen nieuwe punten laten melden",
          "deactivate": "Units deactiveren",
          "give_access": "Klanten toegang geven",
          "revoke_access": "Klanten toegang intrekken"
        },
        "go_to_unit": "Ga naar unit",
        "revokeAccess": "Toegang intrekken",
        "select": "Selecteer type",
        "selectOutdoorCategory": "Selecteer buitenruimte",
        "selectUnit": "Selecteer Unit",
        "setCustomer": "Een klant toewijzen aan ",
        "setVisible": "Toegang geven",
        "submit": "Selecteer",
        "update_pricing": "Prijzen bijwerken",
        "add_email": "E-mailadres toevoegen",
        "retry_skipped": "Opnieuw toegang geven",
        "finish_access": "Klaar"
      },
      "attributes": {
        "address_city": "Stad",
        "address_country": "Land",
        "address_number": "Nummer",
        "address_street": "Straat",
        "address_zip": "Postcode",
        "amount": "Bedrag",
        "bathrooms": "Aantal badkamers",
        "bedrooms": "Aantal slaapkamers",
        "category": "Type",
        "category_outdoor": "Buitenruimte",
        "customer": "Klant",
        "deed_signed_at": "Akte getekend op",
        "description": "Omschrijving",
        "electricity": "Elektriciteit",
        "floor": "Verdieping",
        "house_subcategory": "Type huis",
        "internal_note": "Interne notitie",
        "meter_number": "Tellernummer",
        "meter_number_electricity": "Tellernummer elektriciteit",
        "meter_number_gas": "Tellernummer gas",
        "meter_number_warmth": "Tellernummer warmte",
        "meter_number_water": "Tellernummer water",
        "meter_numbers": "Tellernummers",
        "name": "Naam",
        "orientation": "Oriëntatie",
        "price_value": "Totale verkoopsprijs",
        "price_value_construction": "Constructie aandeel",
        "price_value_construction_existing": "Kosten van bestaande constructie",
        "price_value_fees": "Kosten voor architect / engineering",
        "price_value_land": "Grondaandeel",
        "quotity": "Quotiteit",
        "sales_employee": "Verkoper",
        "surface_garden": "Oppervlakte tuin",
        "surface_terrace": "Oppervlakte terras",
        "surface_total": "Totale oppervlakte",
        "tax_percentage": "Belasting %",
        "toilets": "Aantal toiletten",
        "total": "Totaal",
        "vat_percentage": "BTW %"
      },
      "house_subtype": {
        "detached": "Vrijstaand",
        "rowhouse": "Rijwoning",
        "semidetached": "Half open"
      },
      "labels": {
        "access_skipped_without_email": "{count} toegang overgeslagen omdat de klant geen e-mailadres heeft. | {count} toegangen overgeslagen omdat de klanten geen e-mailadres hebben.",
        "activate": "Activeer",
        "address": "Adres",
        "areYouSureDeactivate": "Weet je zeker dat je {unit_name} wilt deactiveren?",
        "bathrooms": "badkamer | badkamers",
        "bedrooms": "kamer | kamers",
        "cannot_activate_all_units": "Je hebt niet genoeg resterende units om alle geselecteerde units te activeren",
        "customer_can_create_issue_project_off": "Uitgeschakeld voor het hele project in de projectinstellingen.",
        "customer_issue_creation_unit_off": "Voor deze unit kan je geen nieuwe punten meer melden.",
        "deactivate": "Deactiveer",
        "deactivateMessage": "De klant kan nog steeds met je communiceren en heeft nog steeds toegang tot al zijn informatie. Alle andere acties zoals het maken van beslissingen, het uploaden van documenten, het verzenden van enquêtes, etc voor {unit_name} zullen desondanks niet mogelijk zijn.",
        "deactivated": "Gedeactiveerd",
        "notAvailableDeactivated": "Niet beschikbaar voor een gedeactiveerde unit",
        "deedSignedOn": "Akte ondertekend op {date}",
        "deedWillBeSignedOn": "Akte zal worden ondertekend op {date}",
        "detailed_price": "Gedetailleerde prijs",
        "details": "Details",
        "email_address_secondary_delivery_content": "ontvangt wel notificatie-e-mails als voormalig secundair contact",
        "email_address_secondary_delivery_tip": "Deze klant is oorspronkelijk toegevoegd als secundair contact voor de andere klant, voordat ondersteuning voor meerdere klanten per unit werd geïntroduceerd: deze klant zal dezelfde e-mailmeldingen blijven ontvangen als de andere klant, maar alleen de andere klant heeft toegang tot de unit/login.",
        "existingVatValues": "Sommige BTW-waarden zijn anders dan 0",
        "export": "Exporteren",
        "export_preparing": "Het verzamelen van de gegevens van de unit kan enkele seconden duren.",
        "facing": "{direction} georiënteerd",
        "fromATotal": "Projecttotaal: {total}",
        "general": "Algemeen",
        "howDoesCustomerSeeThis": "Hoe ziet de klant deze info?",
        "integrationNoCustomerAssigned": "Geen klant(en) toegewezen, gelieve de klant(en) toe te wijzen in {integration_name}.",
        "internal": "Intern",
        "internalDisclaimer": "Deze informatie is enkel zichtbaar voor het team",
        "invitationAddEmailAddress": "Om de klant {customer} toegang te geven tot de unit, gelieve eerst het emailadres in te vullen op de klant zijn contactpagina.",
        "invitationAddEmailAddress_SUP": "Om {customer} toegang te geven tot het project, vul je eerst het e-mailadres in op de contactpagina van de klant.",
        "invitationSentTo": "{customer} ontvangt zijn uitnodiging binnenkort op {email}",
        "maintainerNoCustomerAssigned": "Geen klant toegewezen, alleen teamleden met de rol 'Eigenaar' kunnen een klant toewijzen aan een unit.",
        "more": "meer",
        "onFloor": "Op niveau",
        "or_create_new": "Nieuw aanmaken",
        "other_units": "Heeft andere units",
        "price_view": "Prijsweergave",
        "sales_value": "Alle prijzen zijn in {currency}",
        "scopes": {
          "invisible": "Geen toegang tot unit",
          "invisible_SUP": "Geen toegang tot project",
          "visible": "Klant heeft toegang tot unit",
          "visible_SUP": "Heeft toegang"
        },
        "scopes_description": {
          "invisible": "De klant heeft nog geen toegang tot deze unit in het klantenportaal",
          "invisible_SUP": "De klant heeft nog geen toegang tot dit project in het klantenportaal",
          "visible": "De klant heeft toegang tot deze unit in het klantenportaal",
          "visible_SUP": "De klant heeft toegang tot deze unit in het klantenportaal"
        },
        "search_unit": "Zoek unit of klant...",
        "selectUnit": "Selecteer een Unit",
        "select_contact_required": "Selecteer eerst een contact",
        "select_existing_contact": "Bestaand",
        "set_unit_price": "Stel de unitprijs in",
        "showUnit": "Toon Unit",
        "simple_price": "Gemakkelijk",
        "toggleDetailedPrice": "Wijzig prijsweergave",
        "unassigned": "Geen klant toegewezen",
        "unit": "Geen unit | Eén unit | {count} Units",
        "unitLabel": "Unit",
        "units": "Units",
        "units_assigned_count": "{assigned} / {total} units",
        "units_not_added": "{count} unit nog niet toegevoegd | {count} units nog niet toegevoegd",
        "utilities": "Nutsvoorzieningen",
        "visibleCustomer": "Deze informatie is zichtbaar voor de klant",
        "access_no_changes": "Er is geen nieuwe toegang gegeven.",
        "access_invitation_notice": "Nieuwe klanten ontvangen een uitnodiging per e-mail. Klanten die al zijn uitgenodigd, krijgen geen nieuwe uitnodiging.",
        "access_skipped_instructions": "Voeg elk ontbrekend e-mailadres toe in het klantprofiel. Kom dan hier terug en probeer opnieuw. Profielen openen in een nieuw tabblad.",
        "access_skipped_owner_instructions": "Alleen eigenaars kunnen e-mailadressen wijzigen. Vraag een eigenaar om de ontbrekende e-mailadressen toe te voegen en probeer daarna opnieuw toegang te geven.",
        "access_skipped_empty": "Geen overgeslagen toegangen.",
        "access_skipped_reason": "E-mailadres ontbreekt",
        "access_granted_customers": "{count} klant heeft toegang gekregen. | {count} klanten hebben toegang gekregen."
      },
      "outdoor_category": {
        "balcony": "Balkon",
        "garden": "Tuin",
        "null": "Geen",
        "terrace": "Terras",
        "terrace_garden": "Terras + Tuin"
      },
      "status": {
        "unavailable": "Onbeschikbaar"
      },
      "toasts": {
        "activateSuccess": "{unit_name} is succesvol geactiveerd",
        "create_fixed": "Unit aangemaakt",
        "create_rundle": "Nieuwe actieve unit aangemaakt. Nog 1 actieve unit resterend. | Nieuwe actieve unit aangemaakt. Nog {count} actieve units resterend.",
        "deactivateSuccess": "{unit_name} is succesvol gedeactiveerd",
        "delete": "Unit verwijderd",
        "update": "Unit gewijzigd"
      },
      "type": {
        "alf": "Assistentiewoning",
        "apartment": "Appartement",
        "cellar": "Kelder",
        "commercial": "Commercieel",
        "duplex": "Duplex",
        "house": "Huis",
        "loft": "Loft",
        "office": "Kantoor",
        "penthouse": "Penthouse",
        "sme": "KMO Unit",
        "studio": "Studio"
      },
      "validation": {
        "needName": "Verplicht veld",
        "needNumber": "Moet een getal zijn (bv. 85)",
        "pricesNotUpdatable": "Sommige of alle prijzen worden gebruikt binnen een betalingsschijf en kunnen daarom niet meer worden gewijzigd. Verwijder eerst die betalingsschijf om de prijzen te bewerken",
        "totalSalesValueNotEqualToParts": "Het lijkt erop dat de totale verkoopwaarde niet gelijk is aan de som van de delen"
      }
    }
  }
}
